import { styled } from '@mui/material/styles';
import { Stack, StackProps } from '@mui/material';
import React from 'react';
import StackWithDivider from '@/components/StackWithDivider';

const ContentDescription = styled(
  (props: StackProps & { hasVerticalMargin: boolean }) => <Stack {...props} />,
)(({ hasVerticalMargin }) => ({
  marginTop: hasVerticalMargin ? '28px' : 0,
  marginBottom: hasVerticalMargin ? '28px' : 0,
  padding: '20px 12px',
  backgroundColor: 'var(--dk-bg-subtle, #F9FAFB)',
  borderRadius: '8px',
  gap: '12px',
  fontSize: '14px',
  color: 'var(--dk-text-secondary, #888D96)',
  p: { margin: 0 },
}));

export default ContentDescription;

export const ContentDivider = styled((props: StackProps & { gap?: string }) => (
  <StackWithDivider {...props} />
))(() => ({}));
